export const NewUserWidgetsType1CacheKey: string = 'pages/types/1/widgets';

/** Marker: TransferState widgets payload is slim (index0 + preload); CSR must fetch full and merge. */
export const NewUserWidgetsType1PartialKey: string = 'pages/types/1/widgets:partial';
